import React from "react";
import { Link } from "react-router-dom";
import siteConfig, { formatPrice } from "../config/siteConfig";
import "../css/privacy.scss";

const faqs = [
  ["How long does delivery take?", "Estimated delivery times depend on destination and are shown in our shipping guide. Tracking is sent by email once an order leaves us."],
  ["When is delivery complimentary?", `Standard delivery is complimentary when your order reaches ${formatPrice(siteConfig.shipping.freeThreshold)}.`],
  ["Can I return an item?", `Eligible unworn items may be returned within ${siteConfig.shipping.returnsWindow} days of delivery with their original tags and packaging.`],
  ["Can I exchange for another size?", "Exchanges are handled as a return followed by a new order, which helps make the replacement available sooner."],
  ["How do I choose a size?", "Use the size choices on each product page. If you are between sizes or need garment-specific guidance, contact our team before ordering."],
  ["How should I care for my purchase?", "Follow the care label inside each garment. Air pieces between wears and use a specialist cleaner for tailored clothing or leather when needed."],
  ["How can I contact you?", `Email ${siteConfig.contact.email}. Our team normally replies during ${siteConfig.contact.hours}.`],
];

function Faqs() {
  return (
    <main className="legal-page privacy-page">
      <header><p className="eyebrow">HELP</p><h1>Frequently asked questions</h1><p>Orders, delivery, returns and product care</p></header>
      <div className="legal-layout">
        <aside><span>On this page</span>{faqs.map(([title], index) => <a href={`#faq-${index + 1}`} key={title}>{String(index + 1).padStart(2, "0")} {title}</a>)}</aside>
        <article>
          <p className="legal-intro">A few quick answers before you order. For anything else, we are happy to help.</p>
          {faqs.map(([title, copy], index) => <section id={`faq-${index + 1}`} key={title}><span>{String(index + 1).padStart(2, "0")}</span><h2>{title}</h2><p>{copy}</p>{index === 0 && <Link className="text-link" to="/shipping">View shipping details</Link>}{index === 2 && <Link className="text-link" to="/returns">View return policy</Link>}</section>)}
        </article>
      </div>
    </main>
  );
}

export default Faqs;
